import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const SimulateImpactDtoSchema = z.object({
  occupancyGap: z.object({
    currentDelta: z.number().nullable(),
    simulatedDelta: z.number().nullable(),
    hint: z.string(),
    message: z.string(),
  }),
  amrGap: z.object({
    currentDelta: z.number().nullable(),
    simulatedDelta: z.number().nullable(),
    hint: z.string(),
    message: z.string(),
  }),
  revenuePerMonthImpact: z.object({
    currentRevenue: z.number().nullable(),
    simulatedRevenue: z.number().nullable(),
    absoluteChange: z.number().nullable(),
    percentageChange: z.number().nullable(),
  }),
  revenueForecast: z.object({
    currentRevenue: z.number().nullable(),
    simulatedRevenue: z.number().nullable(),
    absoluteChange: z.number().nullable(),
    percentageChange: z.number().nullable(),
  }),
});

export type SimulateImpactDto = z.infer<typeof SimulateImpactDtoSchema>;

export const SimulateImpactRequestDtoSchema = z.object({
  simulatedAmr: z.number(),
  simulatedOccupancy: z.number(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
});

export const SimulateImpactResponseDtoSchema = SimulateImpactDtoSchema;

export type SimulateImpactRequestDto = z.infer<
  typeof SimulateImpactRequestDtoSchema
>;

export type SimulateImpactResponseDto = z.infer<
  typeof SimulateImpactResponseDtoSchema
>;

export const simulateImpact = async (
  facilityId: number,
  dto: SimulateImpactRequestDto,
  config?: AxiosRequestConfig<SimulateImpactRequestDto>
) => {
  const data = SimulateImpactRequestDtoSchema.parse(dto);

  return api
    .post(
      `/market-intelligence/facilities/${facilityId}/simulate-impact`,
      data,
      config
    )
    .then(responseContract(SimulateImpactResponseDtoSchema));
};
